import { DatePicker } from "zaman";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";

export const DateField = (props) => {
  const {
    label,
    dir,
    className,
    registration,
    defaultValue = new Date(),
    error,
    leftAddon,
    disabled,
    name,
    rules,
  } = props;
  const {
    control,
    formState: { errors },
  } = useFormContext();
  // initialize new Date value
  /*  useEffect(() => {
    if (registration && registration.onChange) {
      registration.onChange({ target: { value: defaultValue, name: registration.name } });
    }
  }, [registration.onChange]); */

  return (
    <FieldWrapper label={label} error={errors[name]}>
      <div className="flex gap-2">
        <Controller
          rules={rules}
          name={name}
          control={control}
          render={({ field }) => (
            <DatePicker
              {...field}
              direction={dir}
              inputClass={`border-0 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm shadow shadow-gray-400 focus:outline-none focus:ring ease-linear transition-all duration-150 w-full`}
              accentColor="#EF4444"
              round="x4"
              {...registration}
              defaultValue={defaultValue}
            />
          )}
        />
      </div>
    </FieldWrapper>
  );
};

export const FieldWrapper = (props) => {
  const { label, className, error, children, hidden, description } = props;
  return (
    <div className={"mb-5 flex-1"}>
      <label className={"block text-md font-medium text-gray-800 text-right"}>
        {label}
        <div className={label && "mt-1"}>{children}</div>
      </label>
      {error?.message && (
        <div
          role="alert"
          aria-label={error.message}
          className="mt-1 text-sm font-semibold text-red-500 text-right"
        >
          {error.message}
        </div>
      )}
    </div>
  );
};
